import { Afiliado } from './afiliado.entity';

export class FiltroAutorizacion {
    afiliado?: Afiliado;
    desde?: Date;
    hasta?: Date;
    numeroAutorizacion?: number;
}